import { Flex } from "@jsq/ds/core";
import { AnswerQaView } from "./AnswerQaView";
import { GenerationErrorState } from "./GenerationErrorState";
import { GenerationLoadingState } from "./GenerationLoadingState";

export type GenerateFirstDraftStepProps = {
  arenaId: number;
  ddqProdOpsTaskId: string;
  isRunning: boolean;
  hasEverRun: boolean;
  failureMessage: string | null;
  isRunStateKnown: boolean;
  latestSucceededAt: string | null;
  onRerunWhole: () => void;
  onRerunSection: (sectionId: string, sectionTitle: string) => void;
  // Undefined for non-makers — editing structure isn't the checker's call.
  onEditStructure: (() => void) | undefined;
};

// The run itself (polling, the mutation, the modal) is owned by the wizard — StructureDdqStep's
// "Generate first draft" trigger and this step's own re-run triggers all hit the same
// runDdqGeneration mutation against the same task, so there is exactly one hook instance.
export const GenerateFirstDraftStep = ({
  arenaId,
  ddqProdOpsTaskId,
  isRunning,
  hasEverRun,
  failureMessage,
  isRunStateKnown,
  latestSucceededAt,
  onRerunWhole,
  onRerunSection,
  onEditStructure,
}: GenerateFirstDraftStepProps) => {
  if (isRunning) {
    return <GenerationLoadingState />;
  }

  return (
    <Flex flexDirection="column">
      {failureMessage && (
        <GenerationErrorState message={failureMessage} onRetry={onRerunWhole} />
      )}
      {/* Remounting on the latest succeeded run forces a fresh read rather than wiring a
          second refetch path alongside the run-status poll above. */}
      <AnswerQaView
        key={latestSucceededAt ?? "none"}
        arenaId={arenaId}
        ddqProdOpsTaskId={ddqProdOpsTaskId}
        canStartRun={isRunStateKnown}
        hasEverRun={hasEverRun}
        onRerunWhole={onRerunWhole}
        onRerunSection={onRerunSection}
        onEditStructure={onEditStructure}
      />
    </Flex>
  );
};
